import { Box, Dialog, DialogContent, DialogTitle, Typography, SvgIcon } from "@mui/material";
import React, { FC } from "react";
import { Close } from "@mui/icons-material";
import { Slot as TSlot } from "../../types/ForwardLook";

type LookForwardProps = {
    dealerName: string;
    zip: string;
    timeSlots: string[];
    slots: TSlot[];
    open: boolean;
    handleClose: () => void;

}

const TimeSlot: FC<{ times: string[] }> = (props) => {
    const timeSlots: string[] = props.times.filter((val) => val !== "");

    return (
        <Box>
            <Box p={2} bgcolor="#09121d" color="white" textAlign="center">
                <Typography>Time Slot</Typography>
            </Box>
            {
                timeSlots.map((val, index) => {
                    return (
                        <Box key={index} p={2} bgcolor="#d0ebfb" textAlign="center" >
                            <Typography variant="subtitle2" >{val}</Typography>
                        </Box>
                    )
                })
            }
        </Box>
    )
}

const Slot: FC<{ label: string, content: number[] }> = (props): JSX.Element => {
    return (
        <Box>
            <Box p={2} bgcolor="#09121D" color="white" textAlign="center">
                <Typography>{props.label}</Typography>
            </Box>
            {
                props.content.map((val, index) => {
                    return (
                        <Box key={index} p={2} bgcolor={val <= 0 ? "#da5e66" : "#71db4d"} textAlign="center">
                            <Typography variant="subtitle2">{val}</Typography>
                        </Box>
                    )
                })
            }
        </Box>
    )
}

export const LookForwardModal: FC<LookForwardProps> = (props): JSX.Element => {
    const LookForward = (): JSX.Element => {
        return (
            <Box width="100%">
                {props.slots.length ? (
                    <Box display="flex" width="100%" alignItems="center">
                        <TimeSlot times={props.timeSlots} />
                        {props.slots.map((val) => {
                            return (
                                <Slot label={val.label} content={val.content} />
                            )
                        })}
                    </Box>
                ) : (
                    <p>no data found</p>
                )}
            </Box>
        )
    }

    return (
        <Dialog
            open={props.open}
            aria-labelledby="responsive-dialog-title"
            maxWidth="lg"
            onClose={props.handleClose}
        >
            <DialogTitle id="responsive-dialog-title" display="flex" alignItems="center" justifyContent="space-between" >
                <Typography variant="h5" color="#1ba0e9" >
                    {props.slots.length} Day Forward Look for {props.dealerName}, zip code {props.zip}
                </Typography>
                <SvgIcon sx={{ cursor: "pointer" }} onClick={props.handleClose} >
                    <Close />
                </SvgIcon>
            </DialogTitle>
            <DialogContent>
                <LookForward />
            </DialogContent>
        </Dialog>
    )
}